import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWorkflowLanes32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconWorkflowLanes32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 5H5v4h7zm0 6H5v4h7zM5 21v-4h7v4zm0 2v4h7v-4zM5 3a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm22 2h-7v4h7zm0 6h-7v4h7zm-7 10v-4h7v4zm0-18a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWorkflowLanes32);
